export default __webpack_public_path__ + "static/media/Reconciliation of Share Capital Audit.b2cffab0.pdf";